module.exports = __webpack_public_path__ + "market/static/img/failCupImg.068e89a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ques/failCupImg.png
// module id = Di6D
// module chunks = 1